<template>
  <!-- 加载状态 -->
  <div class="dashboard-container"
       v-loading="loading"
      element-loading-text="加载中..."
      element-loading-fullscreen  >

    <!-- 统计卡片区域 -->
    <el-row class="stats-card-row" :gutter="20">
      <stats-card
          v-for="(stat, index) in statsConfig"
          :key="index"
          :title="stat.title"
          :value="stat.value"
          :chart-id="stat.chartId"
      ></stats-card>
    </el-row>

    <!-- 主内容区域 -->
    <el-row class="main-content" :gutter="20">
      <!-- 文章列表区域 -->
      <el-col
          :xs="24"
          :md="16"
          class="article-column"
      >
        <el-card class="article-card">
          <div class="card-header">
            <el-tabs v-model="activeName" @tab-click="handleTabChange">
              <el-tab-pane label="最新" name="first"></el-tab-pane>
              <el-tab-pane label="推荐" name="second"></el-tab-pane>
            </el-tabs>
          </div>

          <div class="article-list">
            <article-item
                v-for="(item, index) in currentArticleList"
                :key="index"
                :article="item"
                @click="forward(item.id)"
            ></article-item>

            <!-- 空状态 -->
            <div v-if="currentArticleList.length === 0 && !loading" class="empty-state">
              <el-empty description="暂无相关内容"></el-empty>
            </div>
          </div>
        </el-card>
      </el-col>

      <!-- 活动专区 (仅在非移动端显示) -->
      <el-col
          :xs="0"
          :md="8"
          class="activity-column"
      >
        <el-card class="activity-card">
          <div class="card-header">
            <div class="card-title">活动专区</div>
          </div>
          <el-divider></el-divider>

          <div class="activity-list">
            <activity-item
                v-for="(activity, index) in activities"
                :key="index"
                :activity="activity"
            ></activity-item>

            <!-- 空状态 -->
            <div v-if="activities.length === 0 && !loading" class="empty-state">
              <el-empty description="暂无活动信息"></el-empty>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import StatsCard from '@/components/index/StatsCard.vue'
import ArticleItem from '@/components/index/ArticleItem.vue'
import ActivityItem from '@/components/index/ActivityItem.vue'
import { formatDate } from '@/utils/date'

export default {
  name: "IndexView",
  components: {
    StatsCard,
    ArticleItem,
    ActivityItem
  },
  data() {
    return {
      loading: true,
      ip: '',
      activeName: 'first',
      // 统计数据配置
      statsConfig: [
        {
          title: '今日新帖数量',
          value: '',
          chartId: 'myChart1',
        },
        {
          title: '当前在线人数',
          value: '',
          chartId: 'myChart2',
        },
        {
          title: '今日访问数量',
          value: '',
          chartId: 'myChart3',
        }
      ],
      LatestArray: [],
      RecommendArray: [],
      activities: [],
      postUrl: '/lqbuckets/question/',
    };
  },
  computed: {
    // 根据当前激活的标签显示对应列表
    currentArticleList() {
      return this.activeName === 'first' ? this.LatestArray : this.RecommendArray
    },
    // 判断是否是移动设备
    isMobile() {
      return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent)
    }
  },
  mounted() {
    this.initPage()
  },
  beforeDestroy() {
  },
  methods: {
    // 初始化页面数据
    async initPage() {
      try {
        this.loading = true
        // 并行请求提高加载效率
        const ipRes = this.getServerIP()

        this.ip = ipRes.message

        // 按顺序加载关键数据
        await this.loadStatsData()
        await this.showLatest(0)
        await this.showRecommend(1)
        await this.loadActivities()
      } catch (error) {
        console.error('页面初始化失败:', error)
        this.$message.error('数据加载失败，请刷新页面重试')
      } finally {
        this.loading = false
      }
    },

    // 加载统计数据
    async loadStatsData() {
      try {
        // 使用Promise.allSettled
        const results = await Promise.allSettled([
          this.$api.indexApi.getNewsData(),
          this.$api.indexApi.getOnlineData(),
          this.$api.indexApi.getVisitsData(),
        ])

        // 分别处理每个请求的结果
        results.forEach((result, index) => {
          if (result.status === 'fulfilled') {
            // 请求成功，更新数据
            this.statsConfig[index].value = result.value.data
          } else {
            // 请求失败，记录错误但不阻断其他请求
            console.error(`统计数据[${index}]加载失败:`, result.reason)
            this.statsConfig[index].value = '加载失败'
          }
        })

        // 检查是否有失败的请求
        const hasFailed = results.some(r => r.status === 'rejected')
        if (hasFailed) {
          this.$message.warning('部分统计数据加载失败')
        }

      } catch (error) {
        console.error('统计数据处理失败:', error)
        this.$message.warning('统计数据加载异常')
      }
    },

    // 标签切换处理
    handleTabChange(tab) {
      if (tab.name === 'first' && this.LatestArray.length === 0) {
        this.showLatest(0)
      }
      if (tab.name === 'second' && this.RecommendArray.length === 0) {
        this.showRecommend(1)
      }
    },

    // 加载最新文章
    async showLatest(data) {
      try {
        const res = await this.$api.indexApi.getQuestionsData(data)
        this.LatestArray = this.formatArticleList(res.data)
      } catch (error) {
        console.error('加载最新文章失败:', error)
        this.$message.error('最新文章加载失败')
      }
    },

    // 加载推荐文章
    async showRecommend(data) {
      try {
        const res = await this.$api.indexApi.getQuestionsData(data)
        this.RecommendArray = this.formatArticleList(res.data)
      } catch (error) {
        console.error('加载推荐文章失败:', error)
        this.$message.error('推荐文章加载失败')
      }
    },

    // 格式化文章列表数据
    formatArticleList(list) {
      return (list || []).map(item => ({
        ...item,
        updateTime: this.formatDate(item.updateTime)
      }))
    },

    // 加载活动数据
    async loadActivities() {
      try {
        // 实际项目中应从API获取
        const activities = [
          '福兴祥深度分销妮维雅2023年2月下半档期活动（南方',
          '福兴祥深度分销妮维雅2023年2月份下半档期活动（北方）',
          '鼎誉酒水部2、3月北方活动',
          '食品一部a2奶粉2月下旬活动价格',
          '食品一部天润2月下半月活动价格',
          '福兴祥大宝2月档期活动',
          '福兴祥妮维雅2月上半档期活动'
        ]

        const dates = ['2023-02-14', '2023-02-14', '2023-02-13', '2023-02-13', '2023-02-13', '2023-02-07', '2023-02-07']

        this.activities = activities.map((title, index) => ({
          title,
          date: dates[index],
          formatDate: this.formatActivityDate(dates[index])
        }))
      } catch (error) {
        console.error('加载活动数据失败:', error)
      }
    },

    // 获取服务器IP
    async getServerIP() {
      return this.$api.indexApi.getServerIP()
    },

    // 增加浏览量
    async increaseVisits(id) {
      try {
        await this.$api.questionApi.increaseVisits(id)
      } catch (error) {
        console.error('增加浏览量失败:', error)
      }
    },

    // 跳转到文章详情
    async forward(id) {
      await this.increaseVisits(id)
      this.$router.push({
        name: 'knowledgeManagement',
        query: { id, ip: this.ip, postUrl: this.postUrl }
      })
    },


    // 格式化日期
    formatDate(dateStr) {
      return formatDate(dateStr, 'yyyy-MM-dd HH:mm')
    },

    // 格式化活动日期
    formatActivityDate(dateStr) {
      const date = new Date(dateStr)
      return {
        day: date.getDate(),
        month: `${date.getMonth() + 1}月`
      }
    }
  }
}
</script>

<style scoped>
.dashboard-container {
  padding: 20px;
}

.stats-card-row {
  margin-bottom: 20px;
}

.main-content {
  margin-top: 20px;
}

.article-column,
.activity-column {
  display: flex;
  flex-direction: column;
}

.article-card,
.activity-card {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
}

.more-link {
  color: #979899;
  cursor: pointer;
  font-size: 16px;
}

.more-link:hover {
  color: #409eff;
}

.article-list {
  padding: 0 14px;
}

.empty-state {
  padding: 40px 0;
  text-align: center;
}

::v-deep .el-card__body {
  padding: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .dashboard-container {
    padding: 10px;
  }

  .stats-card-row {
    margin-bottom: 10px;
  }
}
</style>